import { ListTasksRequestSchema, ListTasksResponseSchema } from './list-tasks.schema';
/**
 * List Tasks Endpoint Contract
 * Retrieves all tasks for the current user
 */ export const listTasksContract = {
    method: 'GET',
    path: '/api/v2/task',
    description: 'Retrieve open processes and pending assignments for current user',
    requestSchema: ListTasksRequestSchema,
    responseSchema: ListTasksResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated'
        }
    }
};

//# sourceMappingURL=list-tasks.contract.js.map